import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import SingleDevice from "@/pages/SingleDevice";
import RoomLobby from "@/pages/RoomLobby";
import RoomLive from "@/pages/RoomLive";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/conversar" element={<SingleDevice />} />
          <Route path="/sala" element={<RoomLobby />} />
          <Route path="/sala/:code" element={<RoomLive />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
